import axios from 'axios';
export function createCEOOperationsApi({endpoints={},sessionToken}={}) {
  const headers = sessionToken ? {Authorization:`Bearer ${sessionToken}`} : {};
  return {
    loadOperations: endpoints.list ? async ({filters,cursor,signal}) => {
      const response = await axios.get(endpoints.list,{params:{...filters,...(cursor?{cursor}:{})},headers,signal,timeout:30000});
      return response.data?.data ?? response.data;
    } : undefined,
    loadOperationDetail: endpoints.detail ? async ({id,signal}) => {
      const response = await axios.get(`${endpoints.detail}/${encodeURIComponent(id)}`,{headers,signal,timeout:30000});
      return response.data?.data ?? response.data;
    } : undefined,
  };
}
